export default "__VITE_ASSET__D7o4lK1o__"